import { ModelBase } from '../../core/model/model-base';

export class User extends ModelBase {
  constructor() {
    super();

    Object.defineProperties(this, {
      _lastLogin: { writable: true, enumerable: false },
    });
  }

  private _lastLogin: Date;

  name: string;
  personName: string;
  password: string;
  phoneNumber: string;
  civicNumber: string;
  userGroups: string[] = [];
  executorGroups: string[] = [];

  get lastLogin(): Date {
    return this._lastLogin;
  }
  set lastLogin(value: Date) {
    this._lastLogin = value;
  }

  get displayName() {
    return this.toString();
  }

  toString(): string {
    return this.personName?.trim() || this.name;
  }
}
